import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './remove_invoice.component.html'
})
export class RemoveInvoiceModalComponent extends BaseSupportModalComponent {
	domainUrl: string;
	siteId: string;
	invoiceNumber: string = '';
	dateTo: string = '';
	tariffId: string = '';

	async ok() {
		if (confirm(`Вы уверены, что хотите отключить оплату для сайта ${this.domainUrl}?`)) {
			await this.supportService.removeInvoice(this.siteId, this.spreader.base.comment).toPromise();

			this.execute();
		}
	}
}
